import { Action } from 'redux'
import { isType } from 'ts-action'
import { IDocumentsReducer } from 'models/Document'
import {
  GetDocuments,
  DocumentsFetching,
  GetDocumentsErrors,
  RemoveFirstDocument,
} from './actions'

const initialState: IDocumentsReducer = {
  meta: {
    code: 0,
    message: '',
  },
  isFetching: false,
  data: [],
}

export const documentsReducer = (
  state = initialState,
  action: Action,
): IDocumentsReducer => {
  if (isType(action, GetDocuments)) {
    const { payload } = action
    return {
      ...state,
      meta: payload.meta,
      data: payload.data,
    }
  }
  if (isType(action, DocumentsFetching)) {
    const { payload } = action
    return {
      ...state,
      isFetching: payload,
    }
  }
  if (isType(action, GetDocumentsErrors)) {
    const { payload } = action
    return {
      ...state,
      error: {
        code: payload.code,
        message: payload.message,
      },
    }
  }
  if (isType(action, RemoveFirstDocument)) {
    const newDocuments = [...state.data]
    newDocuments.shift()
    return {
      ...state,
      data: newDocuments,
    }
  }
  return state
}
